import React, { ReactNode } from 'react';
import { COLORS, device, FONTS } from '../../constants';
import styled from 'styled-components';

type SectionTitleProps = {
  title?: ReactNode;
  fontFamily?: string;
  color?: string;
  size?: number;
  weight?: number;
  lineHeight?: number;
  children?: ReactNode;
};

export const CardTitle = ({
  title,
  fontFamily = FONTS.TITLE,
  color = COLORS.SECTION_TITLE,
  size = 24,
  weight = 400,
  lineHeight = 36,
  children,
}: SectionTitleProps) => (
  <TitleText
    $fontFamily={fontFamily}
    $color={color}
    $size={size}
    $weight={weight}
    $lineHeight={lineHeight}
  >
    {title}
    {children}
  </TitleText>
);

const TitleText = styled.h3<{
  $fontFamily?: string;
  $color?: string;
  $size?: number;
  $weight?: number;
  $lineHeight?: number;
}>`
  font-family: ${props => props.$fontFamily};
  color: ${props => props.$color};
  font-size: ${props => `${props.$size}px`};
  font-weight: ${props => props.$weight};
  line-height: ${props => `${props.$lineHeight}px`};
  white-space: pre-line;
  margin: 0;
  padding: 0;
  @media screen and ${device.md} {
    font-size: 20px;
    line-height: 30px;
    min-height: 0;
  }
  @media screen and ${device.sm} {
    font-size: 14px;
    line-height: 21px;
  }
`;
